<template>
    <div id="filters" class="filters-container">
        <GenericFilter :filters="filters" v-for="filters in mappedFilters" :key="filters.category"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericFilter from './GenericFilter.vue';
export default {
    components: {
        GenericFilter,
    },
    data() {
        return{
        }
    },
    props:{
        giftCollections: Array,
    },
    computed: {
        mappedFilters(){
            var tags = [...new Set(this.giftCollections.flatMap(x => x.tags.filter(y => y.includes("Filter_"))))];
            if(tags.length > 0){
                tags = tags.map((x) =>{
                    const currentArray = x.replace("Filter_","").split("_");
                    if (currentArray.length > 1){
                        var currentObject = { category: currentArray[0], value: currentArray[1], tag: x };
                        return currentObject;
                    }
                })
                var sortedFilters = [];
                sortedFilters = [...tags.reduce((hash, {category,value,tag}) => {
                    const current = hash.get(category) || { category, filters: [] };
                    current.filters.push({ value, tag });
                    return hash.set(category, current);
                }, new Map).values()];
                
                return sortedFilters;
            }

            return [];
        },
    },
    methods: {
    }
}
</script>

<style scoped>
.filters-container{
    width: 15%;
    overflow-y:scroll;
    overflow-x:hidden;
    position: sticky;
    top: 90px;
    left: 0;
    height: calc(100% - 90px);
    transition: all 0.2s linear;
}
</style>